<button
  class="open-map-btn"
  (click)="openMap()"
  [disabled]="loading"
>
  Elegir asientos
  <svg fill="currentColor" viewBox="0 0 24 24" class="icon">
    <path
      clip-rule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      fill-rule="evenodd"
    ></path>
  </svg>
</button>

<div class="modal-overlay" *ngIf="isOpen" (click)="closeModalAndClearProducts()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div *ngIf="loading" class="modal-loading">
    <div class="loading-content">
      <div class="spinner-border text-dark mb-3" role="status"></div>
      <div class="fw-semibold">Cargando mapa de asientos...</div>
    </div>
    </div>
    <button class="close-btn" (click)="closeModalAndClearProducts()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="modal-body">
      <div class="event-info d-none d-lg-flex">
        <twod-event-info
          [event]="event"
          [expanded]="eventInfoExpanded"
          (onOpen)="onOpen('eventInfo')"
          (onClose)="onClose('eventInfo')"
        ></twod-event-info>
        <ticket-types-legend
          (onOpen)="onOpen('legends')"
          (onClose)="onClose('legends')"
          [expanded]="legendExpanded"
          [ticketTypes]="ticketTypes"
        ></ticket-types-legend>
        <div class="selection-summary">
          <seat-selection-summary
            [selectedSeats]="selectedSeats"
            (goToCheckout)="onGoToCheckout()"
            (onOpen)="onOpen('tickets')"
            (onClose)="onClose('tickets')"
            [expanded]="selectedTicketsExpanded"
          ></seat-selection-summary>
        </div>
      </div>

      <div class="map-container">
        <!-- PLACEHOLDER: Your Konva 2D map will go here -->
        <div id="2d-map-container" class="konva-placeholder">
          <!-- Initialize your Konva stage here -->
        </div>
      </div>
    </div>

    <div class="mobile-footer d-lg-none d-block">
      <ticket-types-legend
        [expanded]="false"
        class=""
        [ticketTypes]="ticketTypes"
      ></ticket-types-legend>
      <seat-selection-summary-mobile
        (goToCheckout)="onGoToCheckout()"
        [selectedSeats]="selectedSeats"
      ></seat-selection-summary-mobile>
    </div>

    <!--<div class="modal-footer">
      <button class="btn-cancel" (click)="closeModal()">Cancelar</button>
      <button
        class="btn-confirm"
        (click)="onGoToCheckout()"
        [disabled]="selectedSeats.length === 0"
      >
        Pasar al Checkout
      </button>
    </div>-->
  </div>
</div>

<!-- TOOLTIP -->
<div class="seat-tooltip" id="seatTooltip">
  <div class="tooltip-header">
    <span class="tooltip-section" id="tooltipSection">BLOCK TL</span>
    <button class="tooltip-close-btn" id="tooltipCloseBtn">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
    </button>
  </div>
  <div class="tooltip-info">
    <div class="tooltip-row">
      <span class="tooltip-label" id="tooltipLabel">Fila:</span>
      <span class="tooltip-value" id="tooltipRow">A</span>
    </div>
    <div class="tooltip-row">
      <span class="tooltip-label">Asiento:</span>
      <span class="tooltip-value" id="tooltipSeat">1</span>
    </div>
    <div class="tooltip-row">
      <span class="tooltip-label">Precio:</span>
      <span class="tooltip-price" id="tooltipPrice">RD$10</span>
    </div>
    <div class="tooltip-row">
      <span class="tooltip-label">Estado:</span>
      <span class="tooltip-availability available" id="tooltipAvailability">
        <span class="availability-dot"></span>
        Disponible
      </span>
    </div>
    <button id="tooltipConfirmBtn" class="seat-tooltip-confirm-btn hidden">
      Seleccionar
    </button>
  </div>
</div>
